module.exports = __webpack_public_path__ + "static/media/teygja_bakvodvar_rodur.ff78bcc3.png";